import SelectSearch, { fuzzySearch } from 'react-select-search';

function Select(props) {
  const {
    id, options, value, onChange, placeholder, name, className, search, error, required, open, onBlur = () => {}, reactSelectSearchClass, getOptions, customRenderOption = null, debounce,
  } = props;

  function renderOption(prop, option) {
    if (customRenderOption) return customRenderOption;

    return (
      <button type="button" {...prop} className="py-2 px-4 w-full">
        <div className="flex items-center w-full">
          {option.photo && (
            <img
              className="w-10 h-10 object-cover mr-4 rounded-full"
              alt={option.name}
              src={option.photo}
            />
          )}
          <h4 style={{ textAlign: 'justify' }}>{option.name}</h4>
        </div>
      </button>
    );
  }

  return (
    <div className={`relative w-full cursor-pointer ${className} ${required ? 'required-star' : ''}`}>
      <SelectSearch
        id={id}
        onChange={onChange}
        options={options || []}
        value={value}
        name={name}
        placeholder={placeholder}
        search={search}
        filterOptions={fuzzySearch}
        getOptions={getOptions}
        autoFocus={open}
        onBlur={onBlur}
        renderOption={renderOption}
        debounce={debounce}
        className={reactSelectSearchClass || 'select-search cursor-pointer'}
      />
      {!!error
      && <p className="w-4/5 error-arrow-top text-sm inline-block p-1 pr-4 pl-3 bg-red-700 mt-2 text-white rounded-lg border-white border">{error}</p>}

    </div>

  );
}

export default Select;
